
export default {
  active: 'active',
  archived: 'archived',
  default: 'active'
}
